/*Experience and Certs */

const experiences = [
  {
    period: "May 2022 — Present",
    role: "Experienced Programmer",
    company: "Deloitte",
    description:
      "Working as a Full-Stack Software Engineer on enterprise applications, with a strong focus on Java backend development, Oracle databases, React, REST APIs and DevOps practices.",
    technologies: [
      "Java",
      "Spring Boot",
      "React",
      "Oracle SQL",
      "REST APIs",
      "Docker",
      "CI/CD",
      "Prometheus",
      "Grafana",
      "AWS",
    ],
  },

  {
    period: "Sep 2021 — May 2022",
    role: "Programmer",
    company: "Deloitte",
    description:
      "Developed automation solutions using UiPath and integrated business processes across multiple enterprise systems, improving operational efficiency.",
    technologies: ["UiPath", "Automation", "System Integration"],
  },

  {
    period: "Sep 2020 — Sep 2021",
    role: "Junior Programmer",
    company: "Deloitte",
    description:
      "Managed Linux environments, implemented monitoring solutions and built dashboards to improve system observability and operational reliability.",
    technologies: ["Linux", "Prometheus", "Grafana", "Zabbix"],
  },

  {
    period: "Feb 2020 — Jul 2020",
    role: "Trainee",
    company: "Deloitte",
    description:
      "Participated in the complete software development lifecycle while developing enterprise web applications using the OutSystems platform.",
    technologies: ["OutSystems", "Low-Code", "Web Development"],
  },
];

export default experiences;
